import { render, staticRenderFns } from "./WinningTickets.vue?vue&type=template&id=51b2045a"
import script from "./WinningTickets.vue?vue&type=script&lang=js"
export * from "./WinningTickets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports